import styled, { css } from 'styled-components';

import type { IMailSubscriptionTheme } from '@/shared/themes/types';

import { Required } from './blocks/Input/parts';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;

    ${theme.media.tablet} {
      min-height: 560px;
      border: 1px solid #000000;
    }
  `}
`;

export const Body = styled.div`
  margin: 10px 20px auto;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 5px;

    .react-datepicker {
      transform: scale(1.2);
      margin-top: 22px;
      margin-left: -70px;

      .react-datepicker__triangle {
        left: -12px !important;
      }
    }

    ${theme.media.tablet} {
      .react-datepicker {
        margin-top: 20px;
        margin-left: -40px;
      }
    }
  `}
`;

export const RequiredInfo = styled.div`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    margin: 0;
    font-size: ${theme.fontSizes.medium};
    font-weight: ${theme.fontWeight.medium};
    color: ${theme.defaultDarkColor};
    line-height: 22px;
  `}
`;

export const RequiredFields = styled(Required).attrs(() => ({
  'aria-hidden': 'true',
}))`
  &::before {
    position: initial;
  }
`;
